(function () {
	var root = document.querySelector("[data-hp-hub]");
	if (!root) return;

	var lastVehicleJson = null;
	var pollInterval = null;
	var pollCount = 0;

	/* ── Anti-loop: AbortController for in-flight fetches ── */
	var _fetchController = null;
	var _vehicleChangeTimer = null;

	// Read fallback handle from data attribute with fallback chain
	var fallbackHandle =
		root.getAttribute("data-hp-fallback-collection") || "top-sellers";
	if (!fallbackHandle || fallbackHandle === "") fallbackHandle = "top-sellers";
	// Final fallback to "all" if top-sellers doesn't exist
	var ultimateFallback = "all";

	// Ensure image fixer exists for product cards
	if (typeof window.fixProductImage !== "function") {
		window.fixProductImage = function (imgUrl) {
			if (!imgUrl)
				return "https://cdn.shopify.com/s/files/1/0000/0000/files/placeholder.jpg";
			if (imgUrl.indexOf("//") === 0) return "https:" + imgUrl;
			return imgUrl;
		};
	}

	function safeParse(json) {
		try {
			return JSON.parse(json);
		} catch (e) {
			return [];
		}
	}

	function slugify(str) {
		return String(str || "")
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-+|-+$/g, "");
	}

	function getActiveVehicle() {
		// Canonical getter: prefer window.getGarageSearchTerms, fallback to localStorage
		if (typeof window.getGarageSearchTerms === "function") {
			try {
				var vehicles = window.getGarageSearchTerms();
				if (Array.isArray(vehicles) && vehicles.length > 0) return vehicles[0];
			} catch (e) {}
		}
		var raw = localStorage.getItem("searchTerms");
		var arr = safeParse(raw);
		if (!Array.isArray(arr) || arr.length === 0) return null;
		return arr[0];
	}

	function computeVehicleCollectionHandle(vehicle) {
		if (!vehicle) return "";

		// Prefer vehicle.lastCollection or vehicle.collectionHandle
		if (vehicle.lastCollection) {
			var lc = String(vehicle.lastCollection);
			if (lc.indexOf("/collections/") === 0)
				return slugify(lc.replace("/collections/", ""));
			return slugify(lc);
		}
		if (vehicle.collectionHandle)
			return slugify(String(vehicle.collectionHandle));

		// Try window.generateCollectionHandle
		if (typeof window.generateCollectionHandle === "function") {
			try {
				var ymmStr = vehicle && vehicle.ymm ? String(vehicle.ymm) : "";
				if (!ymmStr && vehicle) {
					var y = vehicle.year ? String(vehicle.year) : "";
					var mk = vehicle.make ? String(vehicle.make) : "";
					var md = vehicle.model ? String(vehicle.model) : "";
					var sm = vehicle.submodel ? String(vehicle.submodel) : "";
					var en = vehicle.engine ? String(vehicle.engine) : "";
					ymmStr = (y + " " + mk + " " + md + " " + sm + " " + en)
						.replace(/\s+/g, " ")
						.trim();
				}
				var handle = window.generateCollectionHandle(ymmStr);
				if (handle) return slugify(handle);
			} catch (e) {}
		}

		// Fallback: slugify YMM
		var ymm =
			vehicle.ymm ||
			(vehicle.year || "") +
				" " +
				(vehicle.make || "") +
				" " +
				(vehicle.model || "");
		return slugify(ymm);
	}

	function computeVehicleCollectionUrl(vehicle) {
		var handle = computeVehicleCollectionHandle(vehicle);
		return handle ? "/collections/" + handle : "";
	}

	function extractImageUrl(product) {
		var imgCandidate = null;

		// Priority: featured_image string or object, images array, fallback
		if (product.featured_image) {
			if (typeof product.featured_image === "string") {
				imgCandidate = product.featured_image;
			} else if (product.featured_image.src) {
				imgCandidate = product.featured_image.src;
			}
		}

		if (!imgCandidate && product.images && product.images.length > 0) {
			var firstImg = product.images[0];
			if (typeof firstImg === "string") {
				imgCandidate = firstImg;
			} else if (firstImg && firstImg.src) {
				imgCandidate = firstImg.src;
			}
		}

		if (!imgCandidate) {
			return (
				window.hpHubNoImageUrl || "data:image/gif;base64,R0lGODlhAQABAAAAACw="
			);
		}

		// Normalize protocol-relative URLs
		if (imgCandidate.indexOf("//") === 0) return "https:" + imgCandidate;
		return imgCandidate;
	}

	function formatPrice(priceInCents) {
		if (!priceInCents || priceInCents === 0) return "";
		return "$" + (priceInCents / 100).toFixed(2);
	}

	function renderProductCard(product) {
		var card = document.createElement("a");
		card.className = "hp-a-prodcard";
		card.href = product.url || "/products/" + product.handle;

		var media = document.createElement("div");
		media.className = "hp-a-prodcard__media";

		var imgUrl = extractImageUrl(product);
		if (typeof window.fixProductImage === "function") {
			imgUrl = window.fixProductImage(imgUrl);
		}

		// Use fallback image if URL is base64 or doesn't contain cdn.shopify.com
		if (
			!imgUrl ||
			imgUrl.indexOf("data:image") === 0 ||
			imgUrl.indexOf("cdn.shopify.com") === -1
		) {
			imgUrl =
				"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/Partify_Photo_Coming_Soon.png?v=1747228850";
		}

		var img = document.createElement("img");
		img.loading = "lazy";
		img.alt = product.title || "";
		img.style.opacity = "0";
		img.style.transition = "opacity .25s ease";
		img.onload = function () {
			img.style.opacity = "1";
		};
		img.src = imgUrl;
		media.appendChild(img);

		var body = document.createElement("div");
		body.className = "hp-a-prodcard__body";

		var title = document.createElement("div");
		title.className = "hp-a-prodcard__title";
		title.textContent = product.title || "";

		var priceText = formatPrice(product.price_min || product.price);
		if (priceText) {
			var price = document.createElement("div");
			price.className = "hp-a-prodcard__price";
			price.textContent = priceText;
			body.appendChild(title);
			body.appendChild(price);
		} else {
			body.appendChild(title);
		}

		card.appendChild(media);
		card.appendChild(body);

		// Track IntelliGems event when popular pick is clicked
		card.addEventListener("click", function () {
			window.igEvents = window.igEvents || [];
			window.igEvents.push({ event: "popularPickClicked" });
		});

		return card;
	}

	function fetchVehicleProducts(vehicle) {
		/* Cancel any in-flight request so only the latest vehicle wins */
		if (_fetchController) {
			try {
				_fetchController.abort();
			} catch (e) {}
		}
		_fetchController =
			typeof AbortController !== "undefined" ? new AbortController() : null;
		var signal = _fetchController ? _fetchController.signal : undefined;

		var ymmStr = "";
		if (vehicle) {
			ymmStr = vehicle.ymm || "";
			if (!ymmStr) {
				var y = vehicle.year ? String(vehicle.year) : "";
				var mk = vehicle.make ? String(vehicle.make) : "";
				var md = vehicle.model ? String(vehicle.model) : "";
				var sm = vehicle.submodel ? String(vehicle.submodel) : "";
				var en = vehicle.engine ? String(vehicle.engine) : "";
				ymmStr = (y + " " + mk + " " + md + " " + sm + " " + en)
					.replace(/\s+/g, " ")
					.trim();
			}
		}

		var vehicleTopWrap = root.querySelector("[data-hp-vehicle-top]");
		var vehicleProdGrid = root.querySelector("[data-hp-vehicle-prodgrid]");
		var topTitle = root.querySelector("[data-hp-top-title]");

		if (!vehicleTopWrap || !vehicleProdGrid || !topTitle) return;

		// If no vehicle, hide the product grid entirely
		if (!vehicle) {
			vehicleTopWrap.style.display = "none";
			return;
		}

		var primaryHandle = computeVehicleCollectionHandle(vehicle);
		if (!primaryHandle) primaryHandle = fallbackHandle;

		var ymm = String(ymmStr || "").trim();

		if (ymm) {
			topTitle.textContent = "Top Parts for " + ymm;
			syncGarageBarUI(ymm);
		} else {
			// No vehicle: use fallback title
			var fallbackTopTitle =
				root.getAttribute("data-hp-fallback-top-title") ||
				"Top Parts right now";
			topTitle.textContent = fallbackTopTitle;
		}

		// Smooth loading state — preserve layout height, fade out old cards
		var currentHeight = vehicleProdGrid.offsetHeight;
		if (currentHeight > 0) {
			vehicleProdGrid.style.minHeight = currentHeight + "px";
		}
		vehicleProdGrid.style.opacity = "0.35";
		vehicleProdGrid.style.transition = "opacity .2s ease";
		vehicleProdGrid.style.pointerEvents = "none";
		vehicleTopWrap.style.display = "";

		var fetchUrl = "/collections/" + primaryHandle + "/products.json?limit=12";

		// Debug logging (guarded by URL param)
		if (typeof URLSearchParams !== "undefined") {
			try {
				var params = new URLSearchParams(window.location.search);
				if (params.has("hubdebug")) {
					console.debug("[Homepage Hub Debug]", {
						vehicle: vehicle,
						ymmStr: ymmStr,
						computedHandle: primaryHandle,
						fetchUrl: fetchUrl,
					});
				}
			} catch (e) {}
		}

		fetch(fetchUrl, { signal: signal })
			.then(function (res) {
				if (!res.ok) throw new Error("Collection not found");
				return res.json();
			})
			.then(function (data) {
				if (!data.products || data.products.length === 0) {
					// Fallback to top-sellers if primary returns empty
					if (primaryHandle !== fallbackHandle) {
						return fetch(
							"/collections/" + fallbackHandle + "/products.json?limit=12",
						).then(function (res) {
							if (!res.ok) {
								// Try 'all' as ultimate fallback
								return fetch("/collections/all/products.json?limit=12").then(
									function (res2) {
										if (!res2.ok) throw new Error("All collections failed");
										return res2.json();
									},
								);
							}
							return res.json();
						});
					} else {
						// Primary IS the fallback, try 'all' collection
						return fetch("/collections/all/products.json?limit=12").then(
							function (res) {
								if (!res.ok) throw new Error("All collection not found");
								return res.json();
							},
						);
					}
				}
				return data;
			})
			.then(function (data) {
				if (!data.products || data.products.length === 0) {
					vehicleProdGrid.style.minHeight = "";
					vehicleProdGrid.style.opacity = "";
					vehicleProdGrid.style.transition = "";
					vehicleProdGrid.style.pointerEvents = "";
					vehicleTopWrap.style.display = "none";
					return;
				}

				// Build new card fragment off-DOM, then swap in one paint frame
				var frag = document.createDocumentFragment();
				const seenTypes = new Set();
				let renderCount = 0;

				if (data.products && data.products.length > 0) {
					data.products.forEach(function (product) {
						if (!product) return;
						if (renderCount >= 4) return;
						const pType = (product.product_type || "General")
							.trim()
							.toLowerCase();
						if (!seenTypes.has(pType)) {
							try {
								frag.appendChild(renderProductCard(product));
								seenTypes.add(pType);
								renderCount++;
							} catch (err) {
								console.error("Error rendering card:", err);
							}
						}
					});
				}

				if (renderCount > 0) {
					// Swap content and fade in within one rAF
					requestAnimationFrame(function () {
						vehicleProdGrid.innerHTML = "";
						vehicleProdGrid.appendChild(frag);
						vehicleTopWrap.style.display = "block";
						// Force a reflow then fade in
						void vehicleProdGrid.offsetHeight;
						vehicleProdGrid.style.minHeight = "";
						vehicleProdGrid.style.opacity = "1";
						vehicleProdGrid.style.transition = "opacity .25s ease";
						vehicleProdGrid.style.pointerEvents = "";
					});
				} else {
					vehicleProdGrid.style.minHeight = "";
					vehicleProdGrid.style.opacity = "";
					vehicleProdGrid.style.transition = "";
					vehicleProdGrid.style.pointerEvents = "";
				}
			})
			.catch(function (err) {
				if (err && err.name === "AbortError") return; // cancelled by newer switch
				console.warn("Vehicle hub fetch failed", {
					primaryHandle: primaryHandle,
					fallbackHandle: fallbackHandle,
					error: err,
				});
				vehicleProdGrid.style.minHeight = "";
				vehicleProdGrid.style.opacity = "";
				vehicleProdGrid.style.transition = "";
				vehicleProdGrid.style.pointerEvents = "";
				vehicleTopWrap.style.display = "none";
			});
	}

	function openVehicleModal() {
		// Try common selectors for vehicle modal triggers
		var selectors = [
			"[data-open-garage]",
			"[data-ymm-open]",
			".js-open-garage",
			'a[href*="vehicle"]',
			'button:contains("ADD A VEHICLE")',
		];

		for (var i = 0; i < selectors.length; i++) {
			var trigger = document.querySelector(selectors[i]);
			if (trigger) {
				trigger.click();
				return;
			}
		}

		// Fallback: try window function
		if (typeof window.toggleGaragePopup === "function") {
			window.toggleGaragePopup();
		}
	}

	function buildVehicleCategoryUrl(
		vehicle,
		categoryFilter,
		categoryProductType,
	) {
		if (!vehicle || !categoryFilter) return "";
		var baseHandle = computeVehicleCollectionHandle(vehicle);
		if (!baseHandle) return "";

		var gridAnchor = "";
		if (document.querySelector("#ProductGridContainer")) {
			gridAnchor = "#ProductGridContainer";
		} else if (document.querySelector("#product-grid")) {
			gridAnchor = "#product-grid";
		}

		var encodedFilter = encodeURIComponent(categoryFilter);
		var href =
			"/collections/" +
			baseHandle +
			"?filter.p.m.custom.collection_types=" +
			encodedFilter;

		if (categoryProductType) {
			var encodedType = encodeURIComponent(categoryProductType);
			href += "&filter.p.product_type=" + encodedType;
		}

		return href + gridAnchor;
	}

	function getVehicleFromUI() {
		var garageTitle = document.getElementById("garage-vehicle-name");
		var titleText = garageTitle ? garageTitle.textContent || "" : "";
		if (titleText && titleText.toLowerCase().indexOf("select") === -1) {
			return { ymm: titleText.trim() };
		}

		var gridTitle =
			document.querySelector("[data-hp-top-title]") ||
			document.querySelector(".collection-hero__title") ||
			document.querySelector(".section-header__title");
		var gridText = gridTitle ? gridTitle.textContent || "" : "";
		if (gridText.indexOf("Top Parts for") !== -1) {
			var ymm = gridText.replace("Top Parts for", "").trim();
			if (ymm) return { ymm: ymm };
		}
		return null;
	}

	function handlePendingCategoryNavigation(vehicle) {
		if (!vehicle) return;
		var pendingFilter = sessionStorage.getItem("pendingCategoryFilter");
		if (!pendingFilter) return;

		var pendingType = sessionStorage.getItem("pendingCategoryProductType");

		// For Top Categories: redirect to category link after vehicle is entered
		// This applies even on homepage when user clicks a Top Category first
		var targetUrl = buildVehicleCategoryUrl(
			vehicle,
			pendingFilter,
			pendingType,
		);

		sessionStorage.removeItem("pendingCategoryFilter");
		sessionStorage.removeItem("pendingCategoryProductType");
		if (targetUrl) window.location.href = targetUrl;
	}
	function updateCategoryTileLinks() {
		var tiles = document.querySelectorAll("[data-category-filter]");
		if (!tiles || tiles.length === 0) return;

		var vehicle = getActiveVehicle() || getVehicleFromUI();

		tiles.forEach(function (tile) {
			var categoryFilter = tile.getAttribute("data-category-filter");
			var categoryProductType = tile.getAttribute("data-category-product-type");
			var defaultHref = tile.getAttribute("data-default-href") || tile.href;
			var productTypeToUse = categoryProductType;
			if (categoryFilter && categoryFilter.indexOf("Bumpers") !== -1) {
				productTypeToUse = null;
			}

			if (vehicle) {
				var href = buildVehicleCategoryUrl(
					vehicle,
					categoryFilter,
					productTypeToUse,
				);
				if (href) tile.setAttribute("href", href);
				tile.onclick = null;
				// Track IntelliGems event when top category navigates
				if (!tile.hasAttribute("data-ig-category-listener-added")) {
					tile.setAttribute("data-ig-category-listener-added", "true");
					tile.addEventListener(
						"click",
						function () {
							window.igEvents = window.igEvents || [];
							window.igEvents.push({ event: "topCategoryNavigated" });
						},
						true,
					);
				}
			} else {
				if (defaultHref) tile.setAttribute("href", defaultHref);
				tile.onclick = function (e) {
					e.preventDefault();
					// Track IntelliGems event when top category is clicked (no vehicle)
					window.igEvents = window.igEvents || [];
					window.igEvents.push({ event: "topCategoryNavigated" });

					if (categoryFilter)
						sessionStorage.setItem("pendingCategoryFilter", categoryFilter);
					if (productTypeToUse)
						sessionStorage.setItem(
							"pendingCategoryProductType",
							productTypeToUse,
						);
					openVehicleModal();
				};
			}
		});
	}

	function syncGarageBarUI(ymmText) {
		var garageTitle =
			document.getElementById("garage-vehicle-name") ||
			document.querySelector(".garage-vehicle-text");
		var garageBtn =
			document.querySelector(".garage-bar__btn") ||
			document.querySelector('button[onclick*="openGarage"]') ||
			document.querySelector('button[onclick*="toggleGaragePopup"]') ||
			document.querySelector(".hero-vehicle-hub .btn");

		if (ymmText) {
			if (garageTitle) garageTitle.textContent = ymmText;
			if (garageBtn) {
				garageBtn.textContent = "CHANGE";
				garageBtn.classList.remove("btn-primary");
			}

			/* REMOVED: setSearchTerms([{ymm}]) call that was writing a
			   stripped-down vehicle object back to localStorage, which
			   dispatched searchTermsUpdated and created a feedback loop.
			   The garage modal already persists vehicles via
			   moveVehicleToFront / setSearchTerms — the homepage hub
			   should only READ, never WRITE vehicle state. */

			// Also update top left header selector
			if (
				typeof window.GarageUI !== "undefined" &&
				window.GarageUI.updateVehicleSelectionElement
			) {
				window.GarageUI.updateVehicleSelectionElement(ymmText);
			}

			/* NOTE: Previously there was a setTimeout that called
			   toggleGaragePopup() to auto-close the old popup.
			   This was closing the V2 garage modal because
			   window.toggleGaragePopup now points to V2's toggle().
			   The V2 garage handles its own close logic — the homepage
			   hub should NEVER close the garage modal. */
		} else {
			if (garageTitle) garageTitle.textContent = "Select Your Vehicle";
			if (garageBtn) {
				garageBtn.textContent = "ADD VEHICLE";
				garageBtn.classList.add("btn-primary");
			}
			// Also update top left header selector
			if (
				typeof window.GarageUI !== "undefined" &&
				window.GarageUI.updateVehicleSelectionElement
			) {
				window.GarageUI.updateVehicleSelectionElement(null);
			}
		}
	}

	window.syncGarageBarUI = syncGarageBarUI;

	function applyState() {
		var vehicle = getActiveVehicle();
		var ymmTitle = root.querySelector("[data-hp-selected-title]");
		var subtitle = root.querySelector("[data-hp-selected-subtitle]");
		var viewAll = root.querySelector("[data-hp-view-all]");
		var selectedHeadingTpl =
			window.hpHubSelectedHeading || "Top Parts for your {ymm}";
		var fallbackUrl = window.hpHubFallbackUrl || "/collections";

		// Always show vehicle-style layout
		root.classList.add("is-selected");

		// Detect product grid anchor
		var gridAnchor = "";
		if (document.querySelector("#ProductGridContainer")) {
			gridAnchor = "#ProductGridContainer";
		} else if (document.querySelector("#product-grid")) {
			gridAnchor = "#product-grid";
		}

		if (vehicle) {
			// Vehicle exists: show vehicle-specific content
			var ymm =
				vehicle.ymm ||
				(vehicle.year || "") +
					" " +
					(vehicle.make || "") +
					" " +
					(vehicle.model || "");
			ymm = String(ymm || "").trim();

			if (ymmTitle)
				ymmTitle.textContent = selectedHeadingTpl.replace("{ymm}", ymm);
			syncGarageBarUI(ymm);

			if (subtitle) {
				var selectedSubtitle = root.getAttribute(
					"data-hp-selected-subtitle-text",
				);
				if (selectedSubtitle) subtitle.textContent = selectedSubtitle;
			}

			var url = computeVehicleCollectionUrl(vehicle);
			if (url && gridAnchor) url += gridAnchor;
			if (viewAll) {
				viewAll.setAttribute("href", url || fallbackUrl);
				// Track IntelliGems event when view all parts is clicked (only add once)
				if (!viewAll.hasAttribute("data-ig-listener-added")) {
					viewAll.setAttribute("data-ig-listener-added", "true");
					viewAll.addEventListener("click", function () {
						window.igEvents = window.igEvents || [];
						window.igEvents.push({ event: "viewAllPartsClicked" });
					});
				}
			}

			fetchVehicleProducts(vehicle);
		} else {
			// No vehicle: show fallback content
			var fallbackTitle =
				root.getAttribute("data-hp-fallback-title") ||
				"Popular picks right now";
			var fallbackSubtitle =
				root.getAttribute("data-hp-fallback-subtitle") ||
				"Add a vehicle for exact fitment, or browse top-selling painted parts.";

			if (ymmTitle) ymmTitle.textContent = fallbackTitle;
			if (subtitle) subtitle.textContent = fallbackSubtitle;

			// Set "view all parts" to /collections/all when no vehicle
			var viewAllUrl = "/collections/all";
			if (viewAll) {
				viewAll.setAttribute("href", viewAllUrl);
				// Track IntelliGems event when view all parts is clicked (only add once)
				if (!viewAll.hasAttribute("data-ig-listener-added")) {
					viewAll.setAttribute("data-ig-listener-added", "true");
					viewAll.addEventListener("click", function () {
						window.igEvents = window.igEvents || [];
						window.igEvents.push({ event: "viewAllPartsClicked" });
					});
				}
			}

			// Hide product grid when no vehicle
			var vehicleTopWrap = root.querySelector("[data-hp-vehicle-top]");
			if (vehicleTopWrap) vehicleTopWrap.style.display = "none";
			syncGarageBarUI(null);
		}

		// Update category tile routing after state is applied
		updateCategoryTileLinks();
		handlePendingCategoryNavigation(vehicle);
	}

	function checkVehicleChange() {
		var vehicle = getActiveVehicle();
		var currentJson = JSON.stringify(vehicle || null);

		if (currentJson !== lastVehicleJson) {
			lastVehicleJson = currentJson;
			applyState();
		}
	}

	function startPolling() {
		if (pollInterval) return;

		pollCount = 0;
		pollInterval = setInterval(function () {
			checkVehicleChange();
			pollCount++;

			// Fast poll for 5 seconds (12 * 400ms = 4.8s), then slow poll
			if (pollCount > 12) {
				clearInterval(pollInterval);
				pollInterval = setInterval(checkVehicleChange, 1500);
			}
		}, 400);
	}

	function attachGarageButtons() {
		var buttons = root.querySelectorAll(".js-open-garage");
		if (!buttons || !buttons.length) return;

		function fallbackClick() {
			var textToFind = "SELECT OR ADD A VEHICLE";
			var candidates = Array.prototype.slice.call(
				document.querySelectorAll("button, a"),
			);
			for (var i = 0; i < candidates.length; i++) {
				var el = candidates[i];
				if (!el || !el.textContent) continue;
				if (el.textContent.trim().toUpperCase().indexOf(textToFind) !== -1) {
					try {
						el.click();
						return;
					} catch (e) {}
				}
			}
		}

		buttons.forEach(function (btn) {
			btn.addEventListener("click", function () {
				if (typeof window.toggleGaragePopup === "function") {
					window.toggleGaragePopup();
				} else {
					fallbackClick();
				}
				startPolling();
			});
		});
	}

	// Expose product fetch for auto-load helpers
	if (typeof window.fetchVehicleProducts !== "function") {
		window.fetchVehicleProducts = function (year, make, model) {
			if (year && typeof year === "object") {
				fetchVehicleProducts(year);
				return;
			}
			fetchVehicleProducts({
				year: year || "",
				make: make || "",
				model: model || "",
			});
		};
	}

	// Initialize
	attachGarageButtons();

	var vehicle = getActiveVehicle();
	lastVehicleJson = JSON.stringify(vehicle || null);
	applyState();

	// Cross-tab sync
	window.addEventListener("storage", function (e) {
		if (e && e.key === "searchTerms") debouncedVehicleCheck();
	});

	/* ── Same-tab vehicle change listeners (Fix F) ──
	   Use a single debounced handler for ALL vehicle-change signals.
	   This collapses the 3–5 events from a single switch into one update. */
	function debouncedVehicleCheck() {
		if (_vehicleChangeTimer) clearTimeout(_vehicleChangeTimer);
		_vehicleChangeTimer = setTimeout(function () {
			_vehicleChangeTimer = null;
			checkVehicleChange();
		}, 120);
	}
	window.addEventListener("partify:vehicle:changed", debouncedVehicleCheck);
	window.addEventListener("searchTermsUpdated", debouncedVehicleCheck);

	// Also register with shared batcher for belt-and-suspenders dedup
	if (window.__partifyVehicleChangeBatcher) {
		window.__partifyVehicleChangeBatcher.onVehicleChange(function () {
			checkVehicleChange();
		});
	}
})();

document.addEventListener("DOMContentLoaded", function () {
	const productGridTitle =
		document.querySelector(".collection-hero__title") ||
		document.querySelector(".section-header__title") ||
		document.querySelector("[data-hp-top-title]");

	let activeVehicle = null;
	if (productGridTitle) {
		const text = productGridTitle.innerText || "";
		if (text.includes("Top Parts for")) {
			activeVehicle = text.replace("Top Parts for", "").trim();
		} else if (text.includes("for ")) {
			activeVehicle = text.split("for ")[1].trim();
		}
	}

	if (activeVehicle) {
		window.syncGarageBarUI(activeVehicle);
		return;
	}

	try {
		const memory = JSON.parse(localStorage.getItem("searchTerms"));
		if (memory && memory.length > 0 && memory[0].ymm) {
			window.syncGarageBarUI(memory[0].ymm);
		} else {
			window.syncGarageBarUI(null);
		}
	} catch (e) {
		window.syncGarageBarUI(null);
	}
});
